import { render, staticRenderFns } from "./UserDialogLoginTabComponent.vue?vue&type=template&id=facb80da&scoped=true"
import script from "./UserDialogLoginTabComponent.js?vue&type=script&lang=js&external"
export * from "./UserDialogLoginTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./UserDialogLoginTabComponent.vue?vue&type=style&index=0&id=facb80da&prod&scoped=true&lang=scss"
import style1 from "./UserDialogLoginTabComponent.vue?vue&type=style&index=1&id=facb80da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facb80da",
  null
  
)

export default component.exports